"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var WebUpdateScreen_1 = __importDefault(require("./WebUpdateScreen"));
exports.default = WebUpdateScreen_1.default;
